import { Callout } from "components/Form/components/Callout/Callout";
import { useEffect, useState } from "react";
import { checkEgressPolicyUserImpact, policyUserImpactMessage } from "./egressMailCheck";

export interface EgressPolicyUserImpactProps {
    resourceData: {
        id?: string;
        enabled?: boolean | null;
        modified_at?: string | null;
    } | null;
}

/**
 * Egress-policy screen panel: an error callout listing the existing users whose
 * email this policy blocks (or would block once enabled). Re-checks after each
 * save (`modified_at` changes). Renders nothing when the policy blocks no
 * user's email or the check fails.
 */
export const EgressPolicyUserImpact = ({ resourceData }: EgressPolicyUserImpactProps) => {
    const [message, setMessage] = useState<string | null>(null);
    const policyId = resourceData?.id;
    const isEnabled = Boolean(resourceData?.enabled);
    const modifiedAt = resourceData?.modified_at;

    useEffect(() => {
        if (!policyId) {
            setMessage(null);
            return undefined;
        }
        let isCurrent = true;
        checkEgressPolicyUserImpact(policyId)
            .then((result) => {
                if (isCurrent) {
                    setMessage(policyUserImpactMessage(result?.users, isEnabled));
                }
            })
            .catch(() => {
                if (isCurrent) {
                    setMessage(null);
                }
            });
        return () => {
            isCurrent = false;
        };
    }, [policyId, isEnabled, modifiedAt]);

    if (!message) {
        return null;
    }
    return <Callout type="error" text={message} className="egressPolicyUserImpact" />;
};
